import React from 'react';
import './Nosotros.css';
import nosotrosBg from '../assets/finanzas.jpg';

const valores = [
  { icon: '⚖️', titulo: 'Integridad', desc: 'Actuamos siempre con ética y respeto en cada una de nuestras operaciones.' },
  { icon: '🔒', titulo: 'Fiabilidad', desc: 'Ofrecemos procesos seguros que generan confianza en nuestros clientes.' },
  { icon: '💬', titulo: 'Claridad', desc: 'Comunicamos de forma transparente para que todo sea comprensible.' },
  { icon: '🤝', titulo: 'Nobleza', desc: 'Mostramos empatía y cercanía para conectar con las necesidades reales de nuestros clientes.' },
];

const equipo = [
  // --- ALTA GERENCIA / DIRECCIÓN ---
  { 
    nombre: 'Josué Mejía', 
    cargo: 'CEO & Fundador', 
    desc: 'Fundador y director, dedicado a impulsar la visión de la institución y al desarrollo de productos financieros.', 
    initials: 'JM', 
    color: 'red',
    imagen: '/equipo/Nestor Josue Mejia Santos.jpeg'
  },
  
  // --- OPERACIONES, CONTABILIDAD Y CONTROL ---
  { 
    nombre: 'Nikaury Tavarez', 
    cargo: 'Encargada de Operaciones', 
    desc: 'Fortalezas en coordinación logística, supervisión de procesos y liderazgo de equipos. Orientada a la eficiencia.', 
    initials: 'NT', 
    color: 'red',
    imagen: '/equipo/Nikaury Tavarez.jpeg'
  },
  { 
    nombre: 'Manuela García', 
    cargo: 'Asistente de Contabilidad', 
    desc: 'Conocimientos en registros contables, conciliaciones bancarias y manejo de documentación financiera.', 
    initials: 'MG', 
    color: 'green',
    imagen: '/equipo/Manuela Garcia Acosta.jpeg'
  },
  { 
    nombre: 'Argenis Medina', 
    cargo: 'Supervisor de Oficiales', 
    desc: 'Experiencia en liderazgo, coordinación de equipos y cumplimiento de metas. Enfocado en optimizar el desempeño operativo.', 
    initials: 'AM', 
    color: 'red',
    imagen: '/equipo/Argenis Medina.jpeg'
  },

  // --- ÁREA COMERCIAL / OFICIALES DE NEGOCIOS ---
  { 
    nombre: 'Luis Hernández', 
    cargo: 'Ejecutivo de Negocios', 
    desc: 'Varios años de experiencia en el sector bancario. Apasionado por ayudar a las personas a alcanzar sus metas financieras.', 
    initials: 'LH', 
    color: 'green',
    imagen: '/equipo/Luis David Hernandez.jpeg'
  },
  { 
    nombre: 'Hansel Estrella', 
    cargo: 'Ejecutivo de Negocios', 
    desc: 'Enfocado en ventas, asesoría financiera y atención al cliente. Hábil en detectar oportunidades y generar relaciones comerciales.', 
    initials: 'HE', 
    color: 'green',
    imagen: '/equipo/Hansel M. Estrella.jpeg'
  },
  { 
    nombre: 'Ezequiel Ortiz', 
    cargo: 'Oficial de Negocio', 
    desc: 'Habilidades en análisis financiero, servicio al cliente y evaluación crediticia. Enfocado en soluciones personalizadas.', 
    initials: 'EO', 
    color: 'green',
    imagen: '/equipo/Ezequiel A. Ortiz.jpeg'
  },
  { 
    nombre: 'Edward Rafael De León', 
    cargo: 'Oficial de Negocio', 
    desc: 'Especialista en atención personalizada, análisis crediticio y desarrollo de relaciones estratégicas.', 
    initials: 'ED', 
    color: 'green',
    imagen: '/equipo/Edward R. Grullon.jpeg'
  },

  // --- ATENCIÓN AL CLIENTE, CAJA Y COBROS ---
  { 
    nombre: 'Darnirys Díaz', 
    cargo: 'Ejecutiva de Negocio', 
    desc: 'Habilidades en atención personalizada, resolución de problemas y gestión de equipos.', 
    initials: 'DD', 
    color: 'red',
    imagen: '/equipo/Darnirys Diaz.jpeg'
  },
  { 
    nombre: 'Oderic E. Veras', 
    cargo: 'Servicio al Cliente', 
    desc: 'Comprometida con ofrecer soporte de excelencia, canalizar solicitudes de manera ágil y brindar soluciones con calidez.', 
    initials: 'OV', 
    color: 'red',
    imagen: '/equipo/Oderic E. Veras.jpeg'
  },
  { 
    nombre: 'Yerely Vargas Vidal', 
    cargo: 'Encargada de Caja', 
    desc: 'Responsable del procesamiento exacto de transacciones financieras, custodia de efectivo y atención al usuario.', 
    initials: 'YV', 
    color: 'green',
    imagen: '/equipo/Yerely Vargas Vidal.jpeg'
  },
  { 
    nombre: 'Jean Carlos García', 
    cargo: 'Encargado de cobros ', 
    desc: 'Especialista en conciliación de cuentas, gestión de cartera vencida y acuerdos de pago bajo términos profesionales.', 
    initials: 'JG', 
    color: 'red',
    imagen: '/equipo/Jean Carlos Garcia.jpeg'
  },

  // --- LOGÍSTICA Y MANTENIMIENTO ---
  { 
    nombre: 'John Anderson Brache', 
    cargo: 'Mensajería', 
    desc: 'Encargado de la logística de distribución de documentos oficiales, diligencias bancarias y soporte operativo externo.', 
    initials: 'JB', 
    color: 'green',
    imagen: '/equipo/John Anderson Brache.jpeg'
  },
  { 
    nombre: 'Epifanía Reinoso', 
    cargo: 'Encargada de Limpieza', 
    desc: 'Experiencia en supervisión y ejecución de tareas de higiene y mantenimiento de espacios seguros.', 
    initials: 'ER', 
    color: 'green',
    imagen: '/equipo/Epifania del carmen r.jpeg'
  }
];

const Nosotros = () => {
  return (
    <div className="nosotros-page">
      {/* PAGE HEADER */}
      <section className="nos-hero">
        <div className="nos-hero-inner">
          <span className="nos-eyebrow">FINANCIERA JM ODEPEM S.R.L.</span>
          <h1 className="nos-h1">
            Sobre <span className="nos-acento">Nosotros</span>
          </h1>
          <p className="nos-subtitulo">
            Somos una financiera comprometida con el bienestar de nuestros clientes. Conoce nuestra historia, valores y equipo.
          </p>
        </div>
        <div className="nos-hero-img-wrap">
          <img src={nosotrosBg} alt="Equipo JM ODEPEM" className="nos-hero-img" />
          <div className="nos-hero-img-overlay"></div>
        </div>
      </section>

      {/* MISIÓN Y VISIÓN */}
      <section className="section mvv-section">
        <div className="container">
          <div className="mvv-grid">
            <div className="mvv-card mision">
              <div className="mvv-icon">🎯</div>
              <h3>Nuestra Misión</h3>
              <p>Somos una entidad financiera que, a través de su asistencia, busca asegurar la satisfacción de sus clientes, siendo líder en la prestación de servicios de financiamiento con una tasa de interés competitiva en el mercado y un trato afable a nuestros clientes.</p>
            </div>
            <div className="mvv-card vision">
              <div className="mvv-icon">🔭</div>
              <h3>Nuestra Visión</h3>
              <p>Convertirnos en la entidad de financiamiento número uno en la región, que garantice la tranquilidad de los clientes a través de acciones claras, procesos innovadores y el buen trato. Sigamos comprometidos con nuestros valores éticos y la calidad en los procesos financieros.</p>
            </div>
          </div>
        </div>
      </section>

      {/* VALORES */}
      <section className="section valores-section">
        <div className="container">
          <div className="section-header-center">
            <span className="section-label">Lo que nos define</span>
            <h2 className="section-title">Nuestros <span>Valores</span></h2>
            <p className="section-subtitle">Los principios que guían cada decisión y acción en Financiera JM ODEPEM.</p>
          </div>
          <div className="valores-grid">
            {valores.map((v, i) => (
              <div key={i} className="valor-card">
                <div className="valor-icon">{v.icon}</div>
                <h3>{v.titulo}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* EQUIPO */}
      <section className="section equipo-section">
        <div className="container">
          <div className="section-header-center">
            <span className="section-label">Nuestro equipo</span>
            <h2 className="section-title">Creamos la solución financiera <span>ideal para usted</span></h2>
            <p className="section-subtitle">Conozca a nuestro equipo de expertos comprometidos con su bienestar financiero.</p>
          </div>
          <div className="equipo-grid">
            {equipo.map((m, i) => (
              <div key={i} className={`miembro-card ${m.color}`}>
                <div className="miembro-img-container">
                  {m.imagen ? (
                    <img src={m.imagen} alt={`Foto de ${m.nombre}`} className="miembro-foto" />
                  ) : (
                    <div className={`miembro-avatar ${m.color}`}>{m.initials}</div>
                  )}
                </div>
                <h3>{m.nombre}</h3>
                <span className={`miembro-cargo ${m.color}`}>{m.cargo}</span>
                <p>{m.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="nosotros-cta-section">
        <div className="container">
          <div className="nosotros-cta-box">
            <div>
              <h2>¿Listo para trabajar <span>con nosotros</span>?</h2>
              <p>Contáctanos hoy y descubre cómo podemos ayudarte a alcanzar tus metas financieras.</p>
            </div>
            <a href="/contacto" className="btn-primary">Contáctanos ahora →</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Nosotros;